module.exports = __webpack_public_path__ + "img/info-icon.7c30bebc.svg";